import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-950 text-background-100">
      <div className="px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex w-9 h-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-basketball-fill text-xl" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">
                nba<span className="text-accent-400">直播</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              权威、高清、实时的 NBA 赛事直播门户，覆盖常规赛与季后赛，实时更新赛程与比分。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">
              <Link to="/live" className="hover:text-accent-400 transition-colors">赛事导航</Link>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-300">
              <li><Link to="/live" className="hover:text-accent-400 transition-colors">直播赛事</Link></li>
              <li><Link to="/schedule" className="hover:text-accent-400 transition-colors">赛程与结果</Link></li>
              <li><Link to="/news" className="hover:text-accent-400 transition-colors">新闻资讯</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">
              <Link to="/about" className="hover:text-accent-400 transition-colors">关于我们</Link>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-300">
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">网站介绍</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">联系方式</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">免责声明</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50">服务时间</h4>
            <p className="mt-4 text-sm text-background-300">周一至周日 全天在线</p>
            <p className="mt-2 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line" /> service@nba-live.example.com
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} nba直播 · 本站为前端演示项目，全部赛事数据为虚构内容，不提供真实直播流。</p>
          <p className="whitespace-nowrap">仅供学习与演示使用</p>
        </div>
      </div>
    </footer>
  );
}